
import { defineComponent, SetupContext, computed, ref, onMounted } from "vue";
import NativeClient, { TitleInfo } from "@/client/native-client";
import { UsedUpPantryList, UsedUpPantryItem } from "@/types/pantry";
import PantryUsedUpCheckItem from "@/components/pantry/PantryUsedUpCheckItem.vue";

export default defineComponent({
  name: "PantryUsedUpCheckView",
  components: {
    PantryUsedUpCheckItem
  },
  props: {
    data: {
      type: UsedUpPantryList,
      default: null,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const getList = () => {
      NativeClient.sendDebugLog("PantryUsedUpCheckView data=" + JSON.stringify(props.data))
      return props.data && props.data.list ? props.data.list : null;
    };
    const onSelectTag = (data: UsedUpPantryItem, foodStatus: number) => {
      NativeClient.sendDebugLog("PantryUsedUpCheckView foodStatus=" + foodStatus + " data=" + JSON.stringify(data));
      context.emit("select-tag", data, foodStatus);
    };
    return {
      getList,
      onSelectTag
    };
  }
});
